import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Box, FlexBox } from '../box';
import { IconButton } from '../button';
import { IconAutoAwesome } from '../icon';
import { styled } from '../styled';
import { getPaletteColor } from '../theme';
import { Tooltip } from '../tooltip';
import { Typography } from '../typography';
import { withVersion } from '../utils';
const HeaderRoot = styled(Box)(({ theme, $variant }) => ({
    boxSizing: 'border-box',
    width: '100%',
    padding: theme.spacing(2),
    overflow: 'hidden',
    background: $variant === 'primary'
        ? `linear-gradient(to right, ${getPaletteColor(theme, 'primary.main')} 0%, ${getPaletteColor(theme, 'primary.dark')} 100%)`
        : getPaletteColor(theme, 'background.paper')
}));
const HeaderIconButton = styled(IconButton)(({ theme, $variant }) => ({
    width: theme.spacing(3.75),
    height: theme.spacing(3.75),
    '& [data-role="icon"]': {
        fill: $variant === 'primary'
            ? getPaletteColor(theme, 'primary.contrastText')
            : getPaletteColor(theme, 'action.active'),
        color: $variant === 'primary'
            ? getPaletteColor(theme, 'primary.contrastText')
            : getPaletteColor(theme, 'action.active'),
        fontSize: theme.spacing(2.5)
    }
}));
const TitleIcon = styled(IconAutoAwesome)(({ theme, $variant }) => ({
    flexShrink: 0,
    fill: $variant === 'primary'
        ? getPaletteColor(theme, 'primary.contrastText')
        : getPaletteColor(theme, 'primary.main'),
    color: $variant === 'primary'
        ? getPaletteColor(theme, 'primary.contrastText')
        : getPaletteColor(theme, 'primary.main'),
    fontSize: theme.spacing(2.5)
}));
const MagicAiHeaderImpl = React.forwardRef(({ title, variant = 'default', shadow = false, onNewChat, newChatTooltip, onBack, onClose, 'data-role': dataRole = 'magic-ai-header', 'data-role-value': dataRoleValue, ...props }, ref) => {
    const textColor = variant === 'primary' ? 'primary.contrastText' : 'text.primary';
    return (_jsx(HeaderRoot, { ref: ref, "$variant": variant, boxShadow: shadow ? 2 : undefined, position: "relative", zIndex: 1, "data-role": dataRole, "data-role-value": dataRoleValue, ...props, children: _jsxs(FlexBox, { gap: 1, vAlign: "center", autoShrink: true, children: [onBack && (_jsx(HeaderIconButton, { "aria-label": "Back", "$variant": variant, icon: "IconChevronLeft", onClick: onBack, size: "small" })), _jsx(TitleIcon, { "$variant": variant }), _jsx(Typography, { color: textColor, lineHeight: 1.5, noWrap: true, variant: "bodyStrong", children: title }), _jsx(FlexBox, { stretch: true }), onNewChat && (_jsx(Tooltip, { title: newChatTooltip, disabled: !newChatTooltip, slotProps: {
                        popper: {
                            sx: {
                                zIndex: 10_000
                            }
                        }
                    }, children: _jsx(HeaderIconButton, { "aria-label": "New chat", "$variant": variant, icon: "IconAdd", onClick: onNewChat, size: "small" }) })), onClose && (_jsx(HeaderIconButton, { "aria-label": "Close", "$variant": variant, icon: "IconClose", onClick: onClose, size: "small" }))] }) }));
});
export const MagicAiHeader = withVersion(MagicAiHeaderImpl, '1.0.0');
